import { message } from "antd";
import { axios } from "../../../constants/axiosConfig";
import {
  SET_OPEN_MODAL_REVISOR,
  SET_OPEN_MODAL_VERBAS_COMUNICADO,
  SET_OPEN_MODAL_REVISOR_BLOQUEIO,
  SET_OPEN_MODAL_BLOQUEIO_MODULO,
  SET_OPEN_MODAL_TERCEIROS_INFORMATIVO,
  SET_OPEN_MODAL_TERCEIROS_VIDEO,
  SET_REDIRECT_TERCEIROS
} from "../actionTypes";

let verbasApiUrl = process.env.REACT_APP_API_VERBAS_URL;

export const setOpenModalVerbasComunicado = (open = false) => {
  return {
    type: SET_OPEN_MODAL_VERBAS_COMUNICADO,
    payload: open,
  };
};

export const setOpenModalRevisor = (open = false) => {
  return {
    type: SET_OPEN_MODAL_REVISOR,
    payload: open,
  };
};

export const setOpenModalRevisorBloqueio = (open = false) => {
  return {
    type: SET_OPEN_MODAL_REVISOR_BLOQUEIO,
    payload: open,
  };
};

export const setOpenModalBloqueioModulo = (open = false) => {
  return {
    type: SET_OPEN_MODAL_BLOQUEIO_MODULO,
    payload: open,
  };
};

export const envioTermosApiVerbas = async (payload) => {
  try {
    const response = await axios.put(
      verbasApiUrl + `/notificacaoCliente`,
      payload
    );

    if (response.data) {
      window.location = process.env.REACT_APP_VERBAS_INSS_URL;
    }
  } catch (e) {
    message.error("Ocorreu um erro ao enviar os termos");
  }
};

export const verificaTermosVerbas = async () => {
  try {
    const response = await axios.get(verbasApiUrl + `/notificacaoCliente`);

    if (!response.data.exibirNotificacao) {
      sessionStorage.setItem("termoAceitoVerbas", true);
    }
  } catch (e) {
    message.error("Ocorreu um erro ao buscar os termos");
  }
};

export const setOpenModalTerceirosInformativo = (open = false) => {
  return {
      type: SET_OPEN_MODAL_TERCEIROS_INFORMATIVO,
      payload: open
  }
}

export const setOpenModalTerceirosVideo = (open = false) => {
  return {
      type: SET_OPEN_MODAL_TERCEIROS_VIDEO,
      payload: open
  }
}

export const setRedirectTerceiros = (redirect = false) => {
  return {
      type: SET_REDIRECT_TERCEIROS,
      payload: redirect
  }
}